import { motion } from 'framer-motion';
import { CHECKBOX_VARIANTS } from '../../constants/checkbox';
import styles from './checkbox.module.css';
import { CheckboxProps } from './checkbox.props';

export const Checkbox = ({ value, onChange }: CheckboxProps) => {
	return (
		<motion.div
			role="button"
			tabIndex={0}
			onClick={() => onChange(!value)}
			onKeyDown={() => onChange(!value)}
			className={styles.container}
			variants={CHECKBOX_VARIANTS.container}
			initial={value ? 'checked' : 'default'}
			animate={value ? 'checked' : 'default'}
		>
			<motion.div variants={CHECKBOX_VARIANTS.content} className={styles.content} />
		</motion.div>
	);
};
